import logo from '../assets/logo.png'
import developer from '../assets/developer.png'
import setting from '../assets/settings.png'
import react from '../assets/react.png'
import git from '../assets/git.png'
import html from '../assets/html.png'
import node from '../assets/node.png'
import redux from '../assets/redux.png'
import sass from '../assets/sass.png'
import typescript from '../assets/typescript.png'
import email from '../assets/email.png'
import javascript from '../assets/javascript.png'

export default { 
  logo,
  setting,
  react,
  git,
  html,
  node,
  redux,
  sass,
  typescript,
  email,
  javascript,
  developer
}